import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Container from '../../../Core/Container';

import { Block, StyledCtas } from './styles';

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
    [BLOCKS.HEADING_1]: (_, children) => (
      <div className="title_large">{children}</div>
    ),
  },
};

const PCSignatureBanner = ({ data }) => {
  if (!data) return null;
  const { heading, headingStyle, bodyCopy, imageDam, ctas } = data;

  const title = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <p className={headingStyle}>{children}</p>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <h3 className={headingStyle}>{children}</h3>
      ),
    },
  };

  return (
    <Container>
      <Block>
        <div>
          <RichText document={heading} options={title} />
          {imageDam && <img src={imageDam.asset.localImage.publicURL} alt="" />}
        </div>
        <div>
          <div>
            <RichText document={bodyCopy} options={body} />
          </div>
          {ctas && <StyledCtas ctas={ctas} alignment="start" />}
        </div>
      </Block>
    </Container>
  );
};

PCSignatureBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PCSignatureBanner;
